import {
  schema
} from 'normalizr';

// Define answer schema
const answerSchema = new schema.Entity('answers', {});

// Define question schema
const questionSchema = new schema.Entity('questions', {
  answers: [ answerSchema ]
});

//Define 
const qatSchema = new schema.Entity('quiz', {
  questions: [questionSchema]
});

export default qatSchema